import React from 'react';
import {connect} from 'react-redux';
import {LanguageContext} from "../App";

const AKADEMIA_URL = 'https://akademia.uczymydzieciprogramowac.pl/pl/wirtualne-puzzle-do-ozobota';

class Share extends React.Component {
    constructor(props) {
        super(props);

        this.setHref = this.setHref.bind(this);
    }

    setHref(e) {
        const split = document.location.href.split('/');
        const hash = split[split.length - 1];
        let url = AKADEMIA_URL;
        url = url.split('/');
        let index = url.length;
        if (e.target.id.includes('PDF')) {
            let format = e.target.id.replace('savePDF', '');
            let size = e.currentTarget.selectedOptions[0].value;
            url.splice(index, 0, 'pdf/' + size + format);
        } else url.splice(index, 0, 'img');
        url.push(hash);
        document.location.href = url.join('/');
        e.currentTarget.selectedIndex = 0;
    }

    copyToClipboard(language) {
        let copyText = document.getElementById("inputLink");
        copyText.select();
        document.execCommand("copy");

        let tooltip = document.getElementById("copyTooltip");
        tooltip.innerHTML = language['skopiowano_do_schowka'];
    }

    outFunc(language) {
        let tooltip = document.getElementById("copyTooltip");
        tooltip.innerHTML = language['kopiuj_do_schowka'];
    }

    selectAll(e) {
        e.target.select();
    }

    render() {
        let url = document.location.href;
        return (
            <LanguageContext.Consumer>
                {({language}) =>
                    <div id="shareContainer">
                        <h5>{language['link']}</h5>
                        <div id="tooltip" className={'w-100'}>
                            <input onFocus={this.selectAll} type="text" value={this.props.puzzleUrl} id="inputLink"
                                readOnly />
                            <button id="copyBtn" onClick={() => { this.copyToClipboard(language); }}
                                onMouseOut={() => { this.outFunc(language); }}>{language['kopiuj']}
                            </button>
                            <span id="copyTooltip">{language['kopiuj_do_schowka']}</span>
                        </div>
                        <div className="fb-share-button mt-3" data-href={url}
                             data-layout="button" data-size="large" data-mobile-iframe="false">
                            <a target="_blank"
                               rel="noopener noreferrer"
                               href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
                               className="fb-xfbml-parse-ignore">{language['udostepnij']}</a>
                        </div>
                        <div className="text-center mt-3 d-flex flex-column justify-content-between">
                            <div className="lastSelect position-relative">
                                <select name="" id="savePDFA4" onChange={this.setHref}>
                                    <option value="100" selected disabled hidden>{language['pobierz_pdf']} A4</option>
                                    <option value="100">{language['rozmiar']}100%</option>
                                    <option value="FTP">{language['rozmiar']}{language['ftp']}</option>
                                </select>
                            </div>
                            <div className="lastSelect d-none" style={{display: 'none'}}>
                                <select style={{'marginTop': '10px'}} name="" id="savePDFA3" onChange={this.setHref}>
                                    <option value="100" selected disabled hidden>{language['pobierz_pdf']} A3</option>
                                    <option value="100">{language['rozmiar']}100%</option>
                                    <option value="FTP">{language['rozmiar']}{language['ftp']}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                }
            </LanguageContext.Consumer>
        )
    }
}

export default connect(
    state => ({
        puzzleUrl: state.puzzleUrl
    })
)(Share)



// WEBPACK FOOTER //
// ./src/RightMenu/Share.js